import { useState, useEffect } from 'react';

import moment from 'moment';
import API from 'service/api';
import Util, { Data } from 'service/util';

import Form from 'component/Form';
import PopMessage from 'component/pop-msg/PopMessage';
import ModalScreen from 'component/ModalScreen';

import DataGridServiceRow from './DataGridServiceRow';

const Counter = (() => {
  let value = 0;
  return Object.freeze({ next: () => value=(1+value) % 100000 });
})();

const DataGridServiceModal = ({vehicle, ...props}) =>
{
  const [error,    setError   ] = useState('');
  const [services, setServices] = useState([]);

  useEffect(() =>
  {
    let initServices = JSON.parse(JSON.stringify(vehicle.services))
    initServices.forEach(s => {
      s._OBJID    = Counter.next();
      s.reg_dtm   = new Date(s.reg_dtm);
      s.start_dtm = new Date(s.start_dtm);
      s.end_dtm   = (s.end_dtm && new Date(s.end_dtm)) || null;
      s.fee       = s.fee || 0;
      s.extra_fee = s.extra_fee || 0;
    });
    sortServices(initServices);
  }, []);

  const submitModal = (e) =>
  {
    e.preventDefault();
    e.stopPropagation();

    sortServices();
    const S = services;

    const _fail_singleNull = () => {
      for (let i = 1; i < S.length; i++)
        if (!S[i].end_dtm)
          return '留空結束日期的紀綠不能超過一列。';
    }
    const _fail_crossTimeline = () => {
      const P = S.map(s => ({sd: moment(s.start_dtm), ed: moment(s.end_dtm || Util.getToday())}))
      for (let i = 0; i < S.length -1; i++)
      for (let j = i+1; j < S.length; j++)
      {
        let [A,B,C,D] = [P[i].sd, P[i].ed, P[j].sd, P[j].ed];
        if (  B.isSameOrAfter( C )
           && D.isSameOrAfter( A ) )
        {
          let [s1,e1,s2,e2] = [A,B,C,D].map(d => Util.ShortDate(d));
          return `日期不能重疊： ${s1} 至 ${e1} / ${s2} 至 ${e2}}`;
        }
      }
    }

    let error = _fail_singleNull() || _fail_crossTimeline();
    if (error) {
      // fail validation
      setError(error);
      PopMessage.show(error, '警告', 'danger');
    } else {
      // clear client side error messages
      setError(error);

      let { cd_license, owner_id } = vehicle;
      let dto = {
        vehicle: { cd_license, owner_id },
        service: JSON.parse(JSON.stringify(services))
      };
      dto.service.forEach(s => {
        s.reg_dtm   = Util.ShortDate(s.reg_dtm);
        s.start_dtm = Util.ShortDate(s.start_dtm);
        s.end_dtm   = s.end_dtm ? Util.ShortDate(s.end_dtm) : null;
        s.fee       = s.fee || 0;
        s.extra_fee = s.extra_fee || 0;
      });
      API.refreshServiceRecord(dto).then(resp => {
        if (!resp.success)
        {
          PopMessage.show(resp.msg, '操作失敗', 'danger');
        } else {
          PopMessage.show('成功', '成功', 'success');
          props.onUpdatedService(resp.msg);
          props.closeModal();
        }
      });
    }

    return false;
  }

  const addRow = () =>
  {
    const today = Util.getToday();
    let row = {
      // default values
      company: Data.company[0].cd,
      reg_dtm: today,
      srv_plan: 'A',
      vh_type: Data.vtype[0].id,
      srv_dis: Data.location[0].srv_dis,
      srv_loc: Data.location[0].srv_loc,
      srv_floor: '', srv_psn: '',
      rotation: '', fee: 0, extra_fee: 0,
      weekday1: 0, weekday2: 0, weekday3: 0,
      waxing: true,
      worker: Data.defaultWorkerId,
      // override above
      ...services[0],
      start_dtm: today,
      end_dtm: null,
      cd_license: vehicle.cd_license,
      owner_id: vehicle.owner_id,
      // override ID
      _OBJID: Counter.next(),
    };
    services.unshift(row);
    sortServices();
  }
  const removeRow = (index) =>
  {
    services.splice(index, 1);
    setServices(Array.from(services));
  }

  const sortServices = (inputServices) =>
  {
    let sortedServices = Array.from(inputServices||services)
    sortedServices.sort((a, b) => {
      let ma = moment(a.start_dtm), mb = moment(b.start_dtm);
      if ( ma.isAfter(mb)  ) return -1; // descending
      if ( ma.isBefore(mb) ) return  1;
      return 0;
    });
    setServices(sortedServices);
  }

  const v = vehicle;
  const S = services;
  return (
    <ModalScreen className="sem sem-grid" show={true}
      title={`服務記錄 - ${v.cd_license}`}
      onClose={props.closeModal}>
      <Form onSubmit={submitModal}>
        <div className="action-panel">
          <button className="btn green" type="button"
                  onClick={addRow}>新增資料列</button>
          <button id="btn-submit" className="btn red" >更新</button>
        </div>
        <div className="advanced-service-edit-grid">
          <table className="data-table full-width" id="table-srvadv">
            <colgroup>
              <col width="38px"  id="col-srvadv-btn" />
              <col width="80px"  id="col-srvadv-company" />
              <col width="110px" id="col-srvadv-reg-date" />
              <col width="110px" id="col-srvadv-start-date" />
              <col width="110px" id="col-srvadv-end-date" />
              <col width="60px"  id="col-srvadv-plan" />
              <col width="100px" id="col-srvadv-district" />
              <col width="100px" id="col-srvadv-location" />
              <col width="100px" id="col-srvadv-floor" />
              <col width="100px" id="col-srvadv-psn" />
              <col width="100px" id="col-srvadv-fee" />
              <col width="100px" id="col-srvadv-rotation" />
              <col width="100px" id="col-srvadv-extra-fee" />
              <col width="210px" id="col-srvadv-server-day" />
              <col width="100px" id="col-srvadv-waxing" />
              <col width="100px" id="col-srvadv-worker" />
            </colgroup>
            <thead>
              <tr>
                <th className="col-srvadv-btn"></th>
                <th className="col-srvadv-company">公司</th>
                <th className="col-srvadv-reg-date">開戶日期</th>
                <th className="col-srvadv-start-date">開始日期</th>
                <th className="col-srvadv-end-date">結束日期</th>
                <th className="col-srvadv-plan">計劃</th>
                <th className="col-srvadv-district">地區</th>
                <th className="col-srvadv-location">車場</th>
                <th className="col-srvadv-floor">樓層</th>
                <th className="col-srvadv-psn">車位</th>
                <th className="col-srvadv-fee">月費</th>
                <th className="col-srvadv-rotation">附加服務</th>
                <th className="col-srvadv-extra-fee">附加費</th>
                <th className="col-srvadv-server-day">服務日</th>
                <th className="col-srvadv-waxing">打蠟</th>
                <th className="col-srvadv-worker">工人</th>
              </tr>
            </thead>
            <tbody>
              { S.map((s, i) => <DataGridServiceRow key={s._OBJID}
                  service={s} sort={sortServices} removeRow={e=>removeRow(i)} />
              )}
            </tbody>
          </table>
        </div>
        <div className="error-msg">{ error }</div>
      </Form>
    </ModalScreen>
  );

}


export default DataGridServiceModal;